// extracted by mini-css-extract-plugin
module.exports = {"red":"style_red__7nf-p","subtitle":"style_subtitle__3a4g-"};